import { render } from "./IconSettings.vue?vue&type=template&id=4215520c&scoped=true"
import script from "./IconSettings.vue?vue&type=script&lang=js"
export * from "./IconSettings.vue?vue&type=script&lang=js"

import "./IconSettings.vue?vue&type=style&index=0&id=4215520c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4215520c"]])

export default __exports__